import { FormattedMessage } from "react-intl";
import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { Modal } from 'react-bootstrap';

import  messages from "../../../locale/messages"
import s from './UpdateTripStatusBookingModal.css';

import {closeEditBookingTripStatusModal} from "../../../actions/siteadmin/modalActions"
import withStyles from "isomorphic-style-loader/withStyles";
import { connect } from "react-redux";
import updateBookingTripStatus from "../../../actions/siteadmin/ManualBooking/updateTripStatus";
class UpdateTripStatusBookingModal extends Component {
    

        render(){
            const {closeEditBookingTripStatusModal, updateTripStatus, booking, dispatch,handleSubmit} = this.props;
            return(
                <div>
                    <Modal show={updateTripStatus} onHide= {closeEditBookingTripStatusModal} className={'wooberlyModal updateTripStatusBookingModal'} backdrop='static'>
                        <Modal.Header closeButton>
                            <Modal.Title >
                                <div className={s.titleDescription}>
                                     <span><FormattedMessage {...messages.updateStatus}/></span>
                                </div>
                            </Modal.Title>
                        </Modal.Header>  
                        <Modal.Body className={s.logInModalBody}>
                            <div className={s.root}>
                                <div className={s.container}>
                                    <span> <FormattedMessage {...messages.descriptionComplete}/></span>
                                
                                </div>
                                <div className={s.footer}>
                                    <button className={s.cancelBtn} onClick={closeEditBookingTripStatusModal}><FormattedMessage {...messages.cancelButton} /></button>
                                <button onClick={async()=>{dispatch(updateBookingTripStatus(booking.id))}} className={s.acceptBtn}> <FormattedMessage {...messages.submitButton}/></button>
                                </div>
                            </div>

                        </Modal.Body>

                    </Modal>
                </div>
            );
        }


}

UpdateTripStatusBookingModal = reduxForm({
    form: "UpdateTripStatusBookingModal", // a unique name for this form
    destroyOnUnmount: false
  })(UpdateTripStatusBookingModal);
const mapState =(state)=> ({
    updateTripStatus: state.adminModalStatus.updateTripStatus,
});
const mapDispatch = {
    closeEditBookingTripStatusModal,
 };

 export default withStyles(s)(connect(mapState,mapDispatch)(UpdateTripStatusBookingModal));